import {getReportParams, report} from '../../../middleware/report';
import {gaEvent} from '../../../utilities/analytics/tracking';

export const otpReportData = {
  OTPPageDisplayed: {
    Channel: 'WebsitePrivate',
    Area: 'SelfCare',
    SubArea: 'OTP',
    ActionType: 'OTP Page',
    Status: 'Ongoing',
    MessageText: 'OTP Page Displayed',
  },
  OTPPageClicked: {
    Channel: 'WebsitePrivate',
    Area: 'SelfCare',
    SubArea: 'OTP',
    ActionType: 'OTP Page',
    Status: 'Ongoing',
    MessageText: 'OTP Page Clicked',
  },
  OTPCodePageDisplayed: {
    Channel: 'WebsitePrivate',
    Area: 'SelfCare',
    SubArea: 'OTP',
    ActionType: 'OTP Code Page',
    Status: 'Ongoing',
    MessageText: 'OTP Code Page Displayed',
  },
  OTPCodePageClicked: {
    Channel: 'WebsitePrivate',
    Area: 'SelfCare',
    SubArea: 'OTP',
    ActionType: 'OTP Code Page',
    Status: 'Ongoing',
    MessageText: 'OTP Code Page Clicked',
  },
  OTPSuccess: {
    Channel: 'WebsitePrivate',
    Area: 'SelfCare',
    SubArea: 'OTP',
    ActionType: 'OTP Code Page',
    Status: 'Completed',
    MessageText: 'Success',
  },
  OTPFailsGeneralError: {
    Channel: 'WebsitePrivate',
    Area: 'SelfCare',
    SubArea: 'OTP',
    ActionType: 'OTP Code Page',
    Status: 'Completed',
    MessageText: 'Error',
  },
};

export const enumGAReport = {
  OtpPhoneContinueButtonClicked: 'OTP Step 1 Phone Continue Button Clicked',
  OtpShowCodePage: 'Otp Show Code Page',
  OtpClickCodePage: 'Otp Click Code Page',
};

export const otpCreateReport = (Channel, Area, SubArea, ActionType, Status, MessageText, Prarm1, Subscriber) => {
  let reportParams = getReportParams();
  reportParams.area = Area;
  reportParams.subArea = SubArea;
  reportParams.channel = Channel;
  reportParams.status = Status;
  reportParams.actionType = ActionType;
  reportParams.messageText = MessageText;
  reportParams.param1 = Prarm1;
  if (Subscriber != '') {
    reportParams.subscriber = Subscriber;
  }
  report(reportParams);
};

export const otpCreateGAReport = (step) => {
  switch (step) {
    case enumGAReport.OtpPhoneContinueButtonClicked:
      gaEvent('TravelInsurance', 'PhoneContinueButton', 'PhoneContinueButton');
      break;

    case enumGAReport.OtpShowCodePage:
      gaEvent('TravelInsurance', 'Otp', 'Otp');
      break;

    case enumGAReport.OtpClickCodePage:
      gaEvent('TravelInsurance', 'OtpContinueButton', 'OtpContinueButton');
      break;
  }
};
